<div class="encuesta-form" [class.encuesta-form--readonly]="isReadonly">
  <div class="encuesta-form__header">
    <div class="encuesta-form__title-row">
      <mat-icon fontSet="material-symbols-outlined" class="encuesta-form__header-icon">assignment</mat-icon>
      <h2>{{ 'titulo_encuesta_solfix' | translate }}</h2>
      @if (isReadonly) {
        <button
          mat-icon-button
          type="button"
          color="warn"
          class="encuesta-form__close"
          [matTooltip]="'cerrar' | translate"
          matTooltipClass="colortooltip"
          [attr.aria-label]="'cerrar' | translate"
          (click)="cerrar()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
    @if (!isReadonly) {
      <p class="encuesta-form__subtitle">{{ 'subtitulo_encuesta' | translate }}</p>
    }
  </div>

  <mat-dialog-content>
    <form [formGroup]="form" class="encuesta-form__body">
      <section class="pregunta">
        <label class="pregunta__label">{{ 'q_recomienda_solfix' | translate }}</label>
        <div
          class="score-row"
          role="group"
          [attr.aria-label]="'q_recomienda_solfix' | translate">
          @for (n of indiceRecomendacionOptions; track n) {
            <button
              type="button"
              class="score-btn"
              [class.score-btn--active]="form.getRawValue().indiceRecomendacion === n"
              [disabled]="isReadonly"
              (click)="seleccionar('indiceRecomendacion', n)">
              {{ n }}
            </button>
          }
        </div>
        <div class="score-hints">
          <span>{{ 'nada_probable' | translate }}</span>
          <span>{{ 'muy_probable' | translate }}</span>
        </div>
      </section>

      <section class="pregunta">
        <label class="pregunta__label">{{ 'q_satisfaccion_general' | translate }}</label>
        <div class="score-row score-row--likert" role="group">
          @for (opt of likertOptions; track opt.value) {
            <button
              type="button"
              class="score-btn"
              [class.score-btn--active]="form.getRawValue().satisfaccionGeneral === opt.value"
              [disabled]="isReadonly"
              (click)="seleccionar('satisfaccionGeneral', opt.value)">
              {{ opt.label }}
            </button>
          }
        </div>
      </section>

      <section class="pregunta">
        <label class="pregunta__label">{{ 'q_facilidad_uso' | translate }}</label>
        <div class="score-row score-row--likert" role="group">
          @for (opt of likertOptions; track opt.value) {
            <button
              type="button"
              class="score-btn"
              [class.score-btn--active]="form.getRawValue().facilidadUso === opt.value"
              [disabled]="isReadonly"
              (click)="seleccionar('facilidadUso', opt.value)">
              {{ opt.label }}
            </button>
          }
        </div>
      </section>

      <section class="pregunta">
        <label class="pregunta__label">{{ 'q_utilidad_modulos' | translate }}</label>
        <div class="score-row score-row--likert" role="group">
          @for (opt of likertOptions; track opt.value) {
            <button
              type="button"
              class="score-btn"
              [class.score-btn--active]="form.getRawValue().utilidadModulos === opt.value"
              [disabled]="isReadonly"
              (click)="seleccionar('utilidadModulos', opt.value)">
              {{ opt.label }}
            </button>
          }
        </div>
      </section>

      <section class="pregunta">
        <label class="pregunta__label">{{ 'comentario_opcional' | translate }}</label>
        <textarea
          class="comentario"
          formControlName="comentario"
          rows="4"
          [placeholder]="'comentario_opcional' | translate"
          [readonly]="isReadonly"></textarea>
      </section>
    </form>
  </mat-dialog-content>

  @if (!isReadonly) {
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cerrar()">{{ 'cancelar' | translate }}</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="form.invalid"
        (click)="enviar()">
        {{ 'enviar_respuestas' | translate }}
      </button>
    </mat-dialog-actions>
  }
</div>
